<template>
	<nk-wrapper v-if="context.bildergalerien" spacing="md">
		<div
			v-if="
				context.bildergalerien[0].bildergalerien_sammlungen &&
				context.bildergalerien[0].bildergalerien_sammlungen.beschreibung
			"
			class="nk-cms-content"
			:class="settings.desc"
			v-html="context.bildergalerien[0].bildergalerien_sammlungen.beschreibung"
		/>
		<nk-row vertical-gutter="3">
			<template
				v-for="(bildergalerie, bildergalerieIndex) in context.bildergalerien"
			>
				<nk-col
					v-if="bildergalerie.bilder.length"
					:key="`bildergalerie-${bildergalerieIndex}-${bildergalerie.id}`"
					:cols="cols.default"
					:sm="cols.sm"
					:md="cols.md"
					:lg="cols.lg"
					:xl="cols.xl"
				>
					<nk-card :variant="settings.cardVariant">
						<template #header>
							<nk-image
								ref="coverImage"
								:note-label="false"
								ar="16:9"
								:src="bildergalerie.bilder[0].bild"
								:copyright="bildergalerie.bilder[0].bildcopyright"
								:alt="bildergalerie.bilder[0].bildtext"
								:lightbox="`lightbox-${bildergalerieIndex}-${bildergalerie.id}`"
								:gallery="bildergalerie.bilder"
							/>
						</template>
						<template #body>
							<a
								href="#"
								:aria-label="'Bildergalerie ' + bildergalerie.titel + ' öffnen'"
								role="button"
								@click.prevent="coverImage[bildergalerieIndex].openGallery()"
							>
								<nk-title :size="settings.titleSize" max-lines="3" no-margin>
									{{ bildergalerie.titel }}
								</nk-title>
							</a>
							<nk-text>
								{{ bildergalerie.bilder.length }}
								{{ bildergalerie.bilder.length > 1 ? 'Bilder' : 'Bild' }}
							</nk-text>
							<div
								v-if="bildergalerie.text"
								class="nk-cms-content"
								v-html="bildergalerie.text"
							/>
						</template>
					</nk-card>
				</nk-col>
			</template>
		</nk-row>
	</nk-wrapper>
</template>

<script>
import {ref, computed} from 'vue';
import {defineSettings} from '../../composables/component';
import TemplatesDefault from '../../mixins/templates-default';

const settings = defineSettings('NkTemplateBildergalerieWebcontact');
const coverImage = ref(null);

/**
 * @prop {string} context.bildergalerien
 * @prop {boolean} options.cols
 */
export default {
	name: 'NkTemplateBildergalerieWebcontact',

	mixins: [TemplatesDefault],

	setup(ctx) {
		const cols = computed(() => {
			return {
				default: ctx.options?.cols?.default || settings.cols.default,
				sm: ctx.options?.cols?.sm || settings.cols.sm,
				md: ctx.options?.cols?.md || settings.cols.md,
				lg: ctx.options?.cols?.lg || settings.cols.lg,
				xl: ctx.options?.cols?.xl || settings.cols.xl,
			};
		});
		return {
			cols,
			coverImage,
			settings,
		};
	},
};
</script>
